<div class="bpx-dialog user-dialog">
  <h2 mat-dialog-title>Edit User</h2>
  <mat-dialog-content>
    <div class="user-dialog__grid">
      <div class="bpx-control">
        <span class="bpx-control__label" id="edit-user-first-name-label">First Name</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
          <input matInput [(ngModel)]="formData.first_name" required aria-labelledby="edit-user-first-name-label" />
        </mat-form-field>
      </div>
      <div class="bpx-control">
        <span class="bpx-control__label" id="edit-user-last-name-label">Last Name</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
          <input matInput [(ngModel)]="formData.last_name" required aria-labelledby="edit-user-last-name-label" />
        </mat-form-field>
      </div>
      <div class="bpx-control">
        <span class="bpx-control__label" id="edit-user-email-label">Email</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
          <input matInput [(ngModel)]="formData.email" disabled aria-labelledby="edit-user-email-label" />
        </mat-form-field>
      </div>
    </div>
    <div class="bpx-error" *ngIf="showErrors && getValidationMessage()" role="alert">
      <mat-icon>error_outline</mat-icon>
      <span>{{ getValidationMessage() }}</span>
    </div>
    <mat-checkbox [(ngModel)]="formData.super_user">Is super user</mat-checkbox>
  </mat-dialog-content>
  <mat-dialog-actions class="user-dialog__actions">
    <button matRipple type="button" class="bpx-btn" (click)="cancel()">Cancel</button>
    <button matRipple type="button" class="bpx-btn bpx-btn--primary" (click)="submit()">Save</button>
  </mat-dialog-actions>
</div>
